import React from 'react';

import CardHOC from './Components/CardHOC';
import LongText from '../../../Types/Components/LongText';

const withLongText = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <LongText question={question} />
  </CardHOC>
}

export default withLongText;